module.exports = __webpack_public_path__ + "static/media/cornucopia.c983e697.png";